"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateProps = exports.tooltipsData = exports.tooltipScroll = exports.toggleTooltipBasedOnScroll = exports.setUpdatedTooltipStyles = exports.repositionTooltip = exports.replaceClassesBasedOnScroll = exports.removeTooltip = exports.removeAllExistingTooltips = exports.getTooltipInfo = exports.generateNewTooltipId = exports.displayTooltip = exports.createDomElements = exports.checkIfSpaceAvailable = exports.adjustPositionPlacement = exports.addInitialTooltipStyles = void 0;
var ReactDOMServer = _interopRequireWildcard(require("react-dom/server"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var createDomElements = function createDomElements(element, x, y, placement) {
  element.style.top = y + "px";
  element.style.left = x + "px";
  addClassesBasedOnPlacement(element, placement);
  return element;
};
exports.createDomElements = createDomElements;
var PRIMARY_BG_COLOR = "#2f2f2f";
var PRIMARY_TEXT_COLOR = "#fff";
var tooltipsData = [];
exports.tooltipsData = tooltipsData;
var count = 0;
var addClassesBasedOnPlacement = function addClassesBasedOnPlacement(element, placement) {
  element.classList.remove("top", "bottom", "left", "right");
  switch (placement) {
    case "top":
      element.classList.add(placement);
      break;
    case "bottom":
      element.classList.add(placement);
      break;
    case "left":
      element.classList.add(placement);
      break;
    case "right":
      element.classList.add(placement);
      break;
    default:
      element.classList.add("top");
  }
};
var checkIfSpaceAvailable = function checkIfSpaceAvailable(tooltipElement, scrollElement) {
  var boundingBox = tooltipElement.getBoundingClientRect();
  var totalWidth = window.innerWidth;
  var totalHeight;
  if (scrollElement) {
    totalHeight = document.querySelector(".".concat(scrollElement)).clientHeight;
  } else {
    totalHeight = window.innerHeight;
  }
  var resultObj = {};
  if (boundingBox.top <= 0 || boundingBox.left <= 0 || boundingBox.right > totalWidth || boundingBox.bottom > totalHeight) {
    resultObj.isSpaceAvailable = false;
  }
  if (boundingBox.top < 0) {
    tooltipElement.classList.remove("top");
    resultObj.placement = "bottom";
  } else if (boundingBox.left < 0) {
    tooltipElement.classList.remove("left");
    resultObj.placement = "right";
  } else if (boundingBox.right > totalWidth) {
    tooltipElement.classList.remove("right");
    resultObj.placement = "left";
  } else if (boundingBox.bottom > totalHeight) {
    tooltipElement.classList.remove("bottom");
    resultObj.placement = "top";
  } else {
    resultObj.isSpaceAvailable = true;
  }
  return resultObj;
};
exports.checkIfSpaceAvailable = checkIfSpaceAvailable;
var adjustPositionPlacement = function adjustPositionPlacement(placement, element, tooltipWidth, tooltipHeight) {
  var x = element.x,
    y = element.y,
    height = element.height,
    width = element.width;
  var halfWidth = width / 2;
  var halfHeight = height / 2;
  var tooltipHalfWidth = tooltipWidth / 2;
  var tooltipHalfHeight = tooltipHeight / 2;
  var scrollHeight = window.scrollY;
  var result;
  if (placement === "top" || placement === "bottom") {
    result = setTooltipVerticalDirection(placement, x, y, tooltipHeight, height, halfWidth, tooltipHalfWidth, scrollHeight);
  } else if (placement === "left" || placement === "right") {
    result = setTooltipHorizontalDirection(placement, x, y, tooltipWidth, width, halfHeight, tooltipHalfHeight, scrollHeight);
  }
  var _result = result,
    top = _result.top,
    left = _result.left;
  return {
    top: top,
    left: left
  };
};
exports.adjustPositionPlacement = adjustPositionPlacement;
var setTooltipVerticalDirection = function setTooltipVerticalDirection(placement, x, y, tooltipHeight, height, halfWidth, tooltipHalfWidth, scrollHeight) {
  var top;
  var left;
  if (placement === "top") {
    top = y - tooltipHeight + scrollHeight;
  } else if (placement === "bottom") {
    top = y + height + scrollHeight;
  }
  left = x + halfWidth - tooltipHalfWidth;
  left = left > 0 ? left : 0;
  return {
    top: top,
    left: left
  };
};
var setTooltipHorizontalDirection = function setTooltipHorizontalDirection(placement, x, y, tooltipWidth, width, halfHeight, tooltipHalfHeight, scrollHeight) {
  var top;
  var left;
  if (placement === "left") {
    left = x - tooltipWidth;
  } else if (placement === "right") {
    left = x + width;
  }
  top = y + halfHeight - tooltipHalfHeight + scrollHeight;
  return {
    top: top,
    left: left
  };
};
var getTooltipInfo = function getTooltipInfo(tooltipElement) {
  var tooltipWidth = tooltipElement.getBoundingClientRect().width;
  var tooltipHeight = tooltipElement.getBoundingClientRect().height;
  return {
    tooltipWidth: tooltipWidth,
    tooltipHeight: tooltipHeight
  };
};
exports.getTooltipInfo = getTooltipInfo;
var repositionTooltip = function repositionTooltip(element, space, targetElement, tooltipWidth, tooltipHeight) {
  if (space.isSpaceAvailable) {
    element.style.visibility = "visible";
  } else {
    var placement = space.placement;
    var _adjustPositionPlacem = adjustPositionPlacement(placement, targetElement, tooltipWidth, tooltipHeight),
      top = _adjustPositionPlacem.top,
      left = _adjustPositionPlacem.left;
    createDomElements(element, left, top, placement);
    element.style.visibility = "visible";
  }
};
exports.repositionTooltip = repositionTooltip;
var addInitialTooltipStyles = function addInitialTooltipStyles(element, id, width, height) {
  element.classList.add("hovertext");
  element.setAttribute("id", "hovertext-".concat(id));
  element.style.visibility = "hidden";
  element.style.maxWidth = width ? width : "";
  if (height) {
    var tooltipContent = document.querySelector("#tooltip-".concat(id));
    tooltipContent.style.maxHeight = height;
    tooltipContent.style.overflow = "auto";
  }
};
exports.addInitialTooltipStyles = addInitialTooltipStyles;
var validateProps = function validateProps(placement, content) {
  var errorMsg;
  if (placement === null || placement === undefined || placement === "") {
    errorMsg = "Please specify Placement prop";
  } else if (content === null || content === undefined || content === "") {
    errorMsg = "Please specify Content prop";
  } else {
    return;
  }
  throw new Error(errorMsg);
};
exports.validateProps = validateProps;
var setUpdatedTooltipStyles = function setUpdatedTooltipStyles(color, bgColor, element, span, placement, target, zIndex) {
  element.style.color = color ? color : PRIMARY_TEXT_COLOR;
  element.style.backgroundColor = bgColor ? bgColor : PRIMARY_BG_COLOR;
  element.style.zIndex = zIndex && zIndex;
  if (placement === "bottom") {
    var left = target.getBoundingClientRect().left - parseInt(element.style.left) + target.getBoundingClientRect().width / 2;
    span.style.left = "".concat(left, "px");
    span.style.borderBottomColor = bgColor ? bgColor : PRIMARY_BG_COLOR;
  } else if (placement === "right") {
    var top = target.getBoundingClientRect().top - parseInt(element.style.top) + target.getBoundingClientRect().height / 2;
    span.style.top = "".concat(top, "px");
    span.style.borderRightColor = bgColor ? bgColor : PRIMARY_BG_COLOR;
  } else if (placement === "left") {
    var _top = target.getBoundingClientRect().top - parseInt(element.style.top) + target.getBoundingClientRect().height / 2;
    span.style.top = "".concat(_top, "px");
    span.style.borderLeftColor = bgColor ? bgColor : PRIMARY_BG_COLOR;
  } else {
    var _left = target.getBoundingClientRect().left - parseInt(element.style.left) + target.getBoundingClientRect().width / 2;
    span.style.left = "".concat(_left, "px");
    span.style.borderTopColor = bgColor ? bgColor : PRIMARY_BG_COLOR;
  }
};
exports.setUpdatedTooltipStyles = setUpdatedTooltipStyles;
var displayTooltip = function displayTooltip(e, element, content, tooltipId, placement, stylingOptions, html, scrollElement, parentClass) {
  var _ref = stylingOptions !== null && stylingOptions !== void 0 ? stylingOptions : {},
    width = _ref.width,
    height = _ref.height,
    bgColor = _ref.bgColor,
    color = _ref.color,
    zIndex = _ref.zIndex;
  document.body.appendChild(element);
  var targetElement;
  var tooltipContentDiv = addTooltipContent(tooltipId, content, html);
  var span = document.createElement("span");
  span.classList.add("tooltip-arrow");
  element.appendChild(span);
  element.appendChild(tooltipContentDiv);
  addInitialTooltipStyles(element, tooltipId, width, height);
  if (parentClass) {
    targetElement = document.querySelector(".".concat(parentClass));
  } else {
    targetElement = e.target;
  }
  var targetElementBoundingRect = targetElement.getBoundingClientRect();
  var _getTooltipInfo = getTooltipInfo(element),
    tooltipWidth = _getTooltipInfo.tooltipWidth,
    tooltipHeight = _getTooltipInfo.tooltipHeight;
  var _adjustPositionPlacem2 = adjustPositionPlacement(placement, targetElementBoundingRect, tooltipWidth, tooltipHeight),
    top = _adjustPositionPlacem2.top,
    left = _adjustPositionPlacem2.left;
  var tooltipElement = createDomElements(element, left, top, placement);
  var space = checkIfSpaceAvailable(tooltipElement, scrollElement);
  repositionTooltip(element, space, targetElementBoundingRect, tooltipWidth, tooltipHeight);
  setUpdatedTooltipStyles(color, bgColor, element, span, element.classList[1], targetElement, zIndex);
  if (html) {
    tooltipContentDiv.innerHTML = "";
  }
  return tooltipContentDiv;
};
exports.displayTooltip = displayTooltip;
var addTooltipContent = function addTooltipContent(tooltipId, content, html) {
  var tooltipContentDiv = document.createElement("div");
  tooltipContentDiv.classList.add("tooltip-content");
  tooltipContentDiv.setAttribute("id", "tooltip-".concat(tooltipId));
  if (!html) {
    tooltipContentDiv.textContent = content;
  }
  if (html) {
    tooltipContentDiv.innerHTML = ReactDOMServer.renderToString(content);
  }
  return tooltipContentDiv;
};
var removeTooltip = function removeTooltip(tooltipId) {
  var tooltipElement = document.getElementById("hovertext-".concat(tooltipId));
  if (tooltipElement) {
    while (tooltipElement.firstChild) {
      tooltipElement.removeChild(tooltipElement.firstChild);
    }
    document.body.removeChild(tooltipElement);
    var tableRow = document.querySelector("#tooltip-".concat(tooltipId));
    if (tableRow) {
      tableRow.classList.remove("table-row-hovertext");
    }
  }
};
exports.removeTooltip = removeTooltip;
var generateNewTooltipId = function generateNewTooltipId() {
  return Date.now().toString().slice(-5);
};
exports.generateNewTooltipId = generateNewTooltipId;
var removeAllExistingTooltips = function removeAllExistingTooltips() {
  var tooltips = document.querySelectorAll(".hovertext");
  if (tooltips.length > 0) {
    tooltips.forEach(function (tooltip) {
      return removeTooltip(tooltip.id.slice(-5));
    });
  }
};
exports.removeAllExistingTooltips = removeAllExistingTooltips;
var removeTooltipOnOutsideClick = function removeTooltipOnOutsideClick() {
  //Start the array counter only if there is some element present in the array
  if (tooltipsData.length !== 0) {
    count++;
  }
  // If the array contains, more than one tooltip, remove the first element from array
  if (count > 1 || tooltipsData.length > 1) {
    removeTooltip(tooltipsData[0]);
    tooltipsData.shift();
    count = 0;
  }
  // If the array contains exactly one tooltip , reset the count to be 1 to delete it next time
  if (tooltipsData.length === 1) {
    count = 1;
  }
};
var toggleTooltipBasedOnScroll = function toggleTooltipBasedOnScroll(className, tooltipTarget, table, tooltip) {
  var tooltipTargetRect = tooltipTarget.getBoundingClientRect();
  var visibilityStatus = "visible";
  if (className === "bottom") {
    if (tooltipTargetRect.top - table.top <= 3) {
      visibilityStatus = "hidden";
    }
  } else {
    if (tooltipTargetRect.bottom - table.bottom >= 20) {
      visibilityStatus = "hidden";
    }
  }
  tooltip.style.visibility = visibilityStatus;
};
exports.toggleTooltipBasedOnScroll = toggleTooltipBasedOnScroll;
var replaceClassesBasedOnScroll = function replaceClassesBasedOnScroll(tooltip, tableWrapper) {
  if (tooltip === null) return;
  var tooltipRect = tooltip.getBoundingClientRect();
  if (tooltipRect.top - tableWrapper.top <= 20) {
    tooltip.classList.add("bottom");
    tooltip.classList.remove("top");
    adjustTooltipArrow("bottom");
  }
  if (tooltipRect.bottom >= tableWrapper.bottom) {
    tooltip.classList.add("top");
    tooltip.classList.remove("bottom");
    adjustTooltipArrow("top");
  }
};
exports.replaceClassesBasedOnScroll = replaceClassesBasedOnScroll;
var adjustTooltipArrow = function adjustTooltipArrow(className) {
  var tooltipArrow = document.querySelector(".tooltip-arrow");
  var borderBottom;
  var borderTop;
  if (className === "top") {
    borderBottom = "transparent";
    borderTop = "#fff";
  } else {
    borderBottom = "#fff";
    borderTop = "transparent";
  }
  tooltipArrow.style.borderBottomColor = borderBottom;
  tooltipArrow.style.borderTopColor = borderTop;
};
var tooltipScroll = function tooltipScroll(targetElementClass, scrollElementParentClass, scrollWrapperClass) {
  var tooltipTarget = document.querySelector(targetElementClass);
  var table = document.querySelector(scrollElementParentClass).getBoundingClientRect();
  var tooltip = document.querySelector(".hovertext");
  if (tooltip === null) return;
  var tableWrapper = document.querySelector(scrollWrapperClass).getBoundingClientRect();
  if (tooltipTarget) {
    replaceClassesBasedOnScroll(tooltip, tableWrapper);
    var targetTop = tooltipTarget.getBoundingClientRect().top;
    if (tooltip.classList.contains("bottom")) {
      toggleTooltipBasedOnScroll("bottom", tooltipTarget, table, tooltip);
      tooltip.style.top = targetTop + 15 + "px";
    } else {
      toggleTooltipBasedOnScroll("top", tooltipTarget, table, tooltip);
      tooltip.style.top = "".concat(targetTop - tooltip.getBoundingClientRect().height, "px");
    }
  }
};
exports.tooltipScroll = tooltipScroll;
document.addEventListener("click", removeTooltipOnOutsideClick);